export const reportExports = {
  edit: "Konfiguration bearbeiten",
  create: "Export anlegen",
  save: "Speichern",
  saveFinished: "Die Konfiguration wurde erfolgreich gespeichert",
  saveFailed: "Die Konfiguration konnte nicht gespeichert werden",
  nameAlreadyTaken:
    "Der Exportname ist bereits vergeben. Bitte wählen Sie einen anderen Namen.",
  runExport: "Export ausführen",
  runExportSuccess: "Der Export wurde erfolgreich gestartet",
  runExportError: "Der Export konnte nicht gestartet werden"
};
